var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GoogleMapLoader',{attrs:{"mapConfig":_vm.mapConfig},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var google = ref.google;
var map = ref.map;
var bounds = ref.bounds;
return _vm._l((_vm.localities),function(locality){return _c('GoogleMapMarker',{key:locality.id,attrs:{"locality":locality,"google":google,"map":map,"bounds":bounds},on:{"openLocality":_vm.openLocality}})})}}])})}
var staticRenderFns = []

export { render, staticRenderFns }